import { SystemColors } from 'melp-design/style';
import { Sx } from 'types/Common';
import { TypographyColor } from 'melp-design/components';

export const variants = ['neutral', 'info'] as const;
export type Variant = (typeof variants)[number];

export const CARD_STYLES_BY_VARIANT: Record<Variant, Sx> = {
  neutral: {
    backgroundColor: SystemColors.white,
    border: `1px solid ${SystemColors.grey[90]}`,
  },
  info: {
    backgroundColor: SystemColors.primary.tint,
    border: `1px solid ${SystemColors.primary.base}`,
  },
};

export const ICON_CONTAINER_STYLES_BY_VARIANT: Record<Variant, Sx> = {
  neutral: {
    backgroundColor: SystemColors.primary.tint,
    color: SystemColors.primary.base,
  },
  info: {
    backgroundColor: SystemColors.primary.base,
    color: SystemColors.white,
  },
};

export const ACTION_COLOR_BY_VARIANT: Record<Variant, TypographyColor> = {
  neutral: 'textPrimary',
  info: 'primary',
};
